<template lang="pug">
  .table-responsive
    table#tbExistencias.table.is-striped.is-fullwidth
      thead
        tr
          th #
          th Categoría(s)
          th Descripción
      tbody
        tr(v-for="(data, index) in articulos" :key="index")
          td
            span.tag.is-black
              | {{ index + 1 }}
          td(v-if="data.subcategoria")
            .control
              .tags.has-addons
                span.tag.is-black
                  i.fas.fa-tag
                  | &nbsp {{ data.categoria}}
                span.tag.is-warning {{ data.subcategoria}}
          td(v-else) 
            span.tag.is-black 
              i.fas.fa-tag
              | &nbsp {{ data.categoria }}
          td 
            p.is-size-6
              .control
                .tags.has-addons
                  span.tag.is-info
                    | {{ data.marca }}
                  span.tag.is-light
                    | {{ data.modelo}}
</template>

<script>

  export default {
    name: 'TbArticulosBase',
    props: {
      articulos: {
        type: Array,
        default: []
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/TbArticulosBase.vue